import axios from "axios";
import { config } from "../../api-helper/api-header-configs";

const baseURL = process.env.REACT_APP_API_URL;

// Create Subcategory
export const create_subcategory = async (values: any) => {
    const payload = {
        subcategory_name: values.subcategory_name,
        category_id: values.category_id,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.post(baseURL + "/subcategories", payload, config);
    return response.data;
}

// List All Subcategories
export const get_all_subcategories = async () => {
    const response = await axios.get(baseURL + "/subcategories", {
        params: {
            _t: Date.now() // Cache busting
        }
    });
    return response.data;
}

// Get Single Subcategory
export const get_subcategory_by_id = async (id: string) => {
    const response = await axios.get(baseURL + `/subcategories/${id}`, config);
    return response.data;
}

// Update Subcategory
export const update_subcategory = async (id: string, values: any) => {
    const payload = {
        subcategory_name: values.subcategory_name,
        category_id: values.category_id,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.patch(baseURL + `/subcategories/${id}`, payload, config);
    return response.data;
}

// Delete Subcategory
export const delete_subcategory = async (id: string) => {
    const response = await axios.delete(baseURL + `/subcategories/${id}`, config);
    return response.data;
}

